const workerIds = new WeakMap<object, number>();
let nextWorkerId = 0;

/**
 * A stable id per worker instance, which every query computed by a panel's worker is keyed on.
 *
 * The panel terminates its worker on unmount, and a comlink call to a terminated worker never settles.
 * react-query refetches a cached query with the `queryFn` it last fetched with, and a remounted panel
 * that finds the result cached (`staleTime: Infinity`) never fetches, so never replaces that function:
 * an invalidation would then await the dead worker for ever — and so would everything awaiting the
 * invalidation, the SphereAI post-write refresh included. Keying on the worker gives each one its own
 * query.
 */
export function workerId(workerApi: object): number {
	let id = workerIds.get(workerApi);
	if (id === undefined) {
		id = nextWorkerId++;
		workerIds.set(workerApi, id);
	}
	return id;
}
